import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ApiEnvelope, unwrapResult } from '../../../operators/unwrap-result.operator';
import {
  CastVoteRequest,
  CorporateActionDetail,
  CorporateActionListItem,
  PendingVote,
  VoteDecision,
} from '../../../models/mysec/corporate-action.model';

@Injectable({
  providedIn: 'root',
})
export class CorporateActionService {
  private readonly baseUrl = environment.apiServer + 'api/v1/CorporateActions';

  constructor(private http: HttpClient) {}

  getCorporateActions(companyId?: number): Observable<CorporateActionListItem[]> {
    const url = companyId != null ? `${this.baseUrl}?companyId=${companyId}` : this.baseUrl;
    return this.http
      .get<ApiEnvelope<CorporateActionListItem[]>>(url)
      .pipe(unwrapResult());
  }

  getCorporateActionDetail(id: number): Observable<CorporateActionDetail> {
    return this.http
      .get<ApiEnvelope<CorporateActionDetail>>(`${this.baseUrl}/${id}`)
      .pipe(unwrapResult());
  }

  castVote(id: number, decision: VoteDecision): Observable<boolean> {
    const payload: CastVoteRequest = { corporateActionId: id, decision };
    return this.http
      .post<ApiEnvelope<boolean>>(`${this.baseUrl}/${id}/vote`, payload)
      .pipe(unwrapResult());
  }

  getPendingVote(): Observable<PendingVote | null> {
    return this.http
      .get<ApiEnvelope<PendingVote | null>>(`${this.baseUrl}/pending-vote`)
      .pipe(unwrapResult());
  }
}
